import { render, staticRenderFns } from "./test_issue_body.vue?vue&type=template&id=5a477186&"
import script from "./test_issue_body.vue?vue&type=script&lang=js&"
export * from "./test_issue_body.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "test_issue_body.vue"
export default component.exports